import { produce } from "immer";
import {
  GET_PREVIEW,
  GET_PREVIEW_SUCCESS,
  GET_PREVIEW_FAILURE,
  //
  GET_TEMPLATE_DATA,
  GET_TEMPLATE_DATA_SUCCESS,
  GET_TEMPLATE_DATA_FAILURE,
  //
  SAVE_TEMPLATE_DATA,
  SAVE_TEMPLATE_DATA_SUCCESS,
  SAVE_TEMPLATE_DATA_FAILURE,
  //
  UPLOAD_FILE,
  UPLOAD_FILE_SUCCESS,
  UPLOAD_FILE_FAILURE,
  //
  DELETE_FILE,
  DELETE_FILE_SUCCESS,
  DELETE_FILE_FAILURE,
  //
  SEARCH_TEMPLATES,
  SEARCH_TEMPLATES_SUCCESS,
  SEARCH_TEMPLATES_FAILURE,
  //
  GET_CARE_SUMMARY,
  GET_CARE_SUMMARY_SUCCESS,
  GET_CARE_SUMMARY_FAILURE,
  //
  GET_VERSION_DATA,
  GET_VERSION_DATA_SUCCESS,
  GET_VERSION_DATA_FAILURE,
  //
  UPDATE_TEMPLATE_DATA,
  UPDATE_TEMPLATE_DATA_SUCCESS,
  UPDATE_TEMPLATE_DATA_FAILURE,
  //
  SAVE_SNAPSHOT,
  SAVE_SNAPSHOT_SUCCESS,
  SAVE_SNAPSHOT_FAILURE,
  //
  GET_OBSERVATIONS,
  GET_OBSERVATIONS_SUCCESS,
  GET_OBSERVATIONS_FAILURE,
  //
  DELETE_VERSION,
  DELETE_VERSION_SUCCESS,
  DELETE_VERSION_FAILURE,
  //
  GET_CURRENT_TEMPLATE,
  GET_CURRENT_TEMPLATE_SUCCESS,
  GET_CURRENT_TEMPLATE_FAILURE,
  //
  SAVE_OBSERVATION,
  SAVE_OBSERVATION_SUCCESS,
  SAVE_OBSERVATION_FAILURE,
  //
  ADD_TEMPLATE_DATA,
  ADD_TEMPLATE_DATA_SUCCESS,
  ADD_TEMPLATE_DATA_FAILURE,
  //
  GET_REVISION,
  GET_REVISION_SUCCESS,
  GET_REVISION_FAILURE,
  //
  VIEW_REVISION,
  VIEW_REVISION_SUCCESS,
  VIEW_REVISION_FAILURE,
  //
  GET_GOVERNANCE_STATS,
  GET_GOVERNANCE_STATS_SUCCESS,
  GET_GOVERNANCE_STATS_FAILURE,
  //
  UPDATE_PLAN_STATUS,
  UPDATE_PLAN_STATUS_SUCCESS,
  UPDATE_PLAN_STATUS_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingPreview: false,
  preview: [],
  isFetchingTemplateData: false,
  templateData: null,
  isSavingTemplateData: false,
  isUploadingFile: false,
  isDeletingFile: false,
  file: null,
  isSearchingTemplates: false,
  templates: [],
  isFetchingCareSummary: false,
  careSummary: null,
  isFetchingVersionData: false,
  versionData: null,
  isUpdatingTemplateData: false,
  updatedTemplateData: null,
  isSavingSnapshot: false,
  savedSnapshot: null,
  isFetchingObservations: false,
  observations: {},
  isDeletingVersion: false,
  isFetchingCurrentTemplate: false,
  currentTemplate: null,
  isSavingObservation: false,
  isAddingTemplateData: false,
  isFetchingHistory: false,
  history: [],
  isViewingRevision: false,
  revision: null,
  isFetchingGovernanceStats: false,
  governanceStats: null,
  isUpdatingPlanStatus: false,
};

const ResidentAssessmentReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case GET_PREVIEW:
        draft.isFetchingPreview = true;
        draft.preview = [];
        break;
      case GET_PREVIEW_SUCCESS:
        draft.isFetchingPreview = false;
        draft.preview = action.payload;
        break;
      case GET_PREVIEW_FAILURE:
        draft.preview = [];
        draft.isFetchingPreview = false;
        break;
      // Template Data
      case GET_TEMPLATE_DATA:
        draft.isFetchingTemplateData = true;
        draft.templateData = null;
        break;
      case GET_TEMPLATE_DATA_SUCCESS:
        draft.isFetchingTemplateData = false;
        draft.templateData = action.payload;
        break;
      case GET_TEMPLATE_DATA_FAILURE:
        draft.isFetchingTemplateData = false;
        draft.templateData = null;
        break;
      // Save Template Data
      case SAVE_TEMPLATE_DATA:
        draft.isSavingTemplateData = true;
        break;
      case SAVE_TEMPLATE_DATA_SUCCESS:
        draft.isSavingTemplateData = false;
        break;
      case SAVE_TEMPLATE_DATA_FAILURE:
        draft.isSavingTemplateData = false;
        break;
      // Upload File
      case UPLOAD_FILE:
        draft.isUploadingFile = true;
        break;
      case UPLOAD_FILE_SUCCESS:
        draft.isUploadingFile = false;
        break;
      case UPLOAD_FILE_FAILURE:
        draft.isUploadingFile = false;
        break;
      // Delete File
      case DELETE_FILE:
        draft.isDeletingFile = true;
        break;
      case DELETE_FILE_SUCCESS:
        draft.isDeletingFile = false;
        break;
      case DELETE_FILE_FAILURE:
        draft.isDeletingFile = false;
        break;
      // Search Templates
      case SEARCH_TEMPLATES:
        draft.isSearchingTemplates = true;
        draft.templates = [];
        break;
      case SEARCH_TEMPLATES_SUCCESS:
        draft.isSearchingTemplates = false;
        draft.templates = action.payload;
        break;
      case SEARCH_TEMPLATES_FAILURE:
        draft.isSearchingTemplates = false;
        draft.templates = [];
        break;
      // Get Care Summary
      case GET_CARE_SUMMARY:
        draft.isFetchingCareSummary = true;
        draft.careSummary = null;
        break;
      case GET_CARE_SUMMARY_SUCCESS:
        draft.isFetchingCareSummary = false;
        draft.careSummary = action.payload;
        break;
      case GET_CARE_SUMMARY_FAILURE:
        draft.isFetchingCareSummary = false;
        draft.careSummary = null;
        break;
      // Get Version Data
      case GET_VERSION_DATA:
        draft.isFetchingVersionData = true;
        draft.versionData = null;
        break;
      case GET_VERSION_DATA_SUCCESS:
        draft.isFetchingVersionData = false;
        draft.versionData = action.payload;
        break;
      case GET_VERSION_DATA_FAILURE:
        draft.isFetchingVersionData = false;
        draft.versionData = null;
        break;
      // Update Template Data
      case UPDATE_TEMPLATE_DATA:
        draft.isUpdatingTemplateData = true;
        draft.updatedTemplateData = null;
        break;
      case UPDATE_TEMPLATE_DATA_SUCCESS:
        draft.isUpdatingTemplateData = false;
        draft.updatedTemplateData = action.payload;
        break;
      case UPDATE_TEMPLATE_DATA_FAILURE:
        draft.isUpdatingTemplateData = false;
        draft.updatedTemplateData = null;
        break;
      // Save Snapshot
      case SAVE_SNAPSHOT:
        draft.isSavingSnapshot = true;
        draft.savedSnapshot = null;
        break;
      case SAVE_SNAPSHOT_SUCCESS:
        draft.isSavingSnapshot = false;
        draft.savedSnapshot = action.payload;
        break;
      case SAVE_SNAPSHOT_FAILURE:
        draft.isSavingSnapshot = false;
        draft.savedSnapshot = null;
        break;
      // Get Observations
      case GET_OBSERVATIONS:
        draft.isFetchingObservations = true;
        // Don't reset observations for lazy loading - let saga handle it
        if (action.payload?.resetData) {
          draft.observations = {};
        }
        break;
      case GET_OBSERVATIONS_SUCCESS:
        draft.isFetchingObservations = false;
        draft.observations = action.payload;
        break;
      case GET_OBSERVATIONS_FAILURE:
        draft.isFetchingObservations = false;
        draft.observations = {};
        break;
      // Delete Version
      case DELETE_VERSION:
        draft.isDeletingVersion = true;
        break;
      case DELETE_VERSION_SUCCESS:
        draft.isDeletingVersion = false;
        break;
      case DELETE_VERSION_FAILURE:
        draft.isDeletingVersion = false;
        break;
      // Get Assessment Data
      case GET_CURRENT_TEMPLATE:
        draft.isFetchingCurrentTemplate = true;
        draft.currentTemplate = null;
        break;
      case GET_CURRENT_TEMPLATE_SUCCESS:
        draft.isFetchingCurrentTemplate = false;
        draft.currentTemplate = action.payload;
        break;
      case GET_CURRENT_TEMPLATE_FAILURE:
        draft.isFetchingCurrentTemplate = false;
        draft.currentTemplate = null;
        break;
      // Save Observation
      case SAVE_OBSERVATION:
        draft.isSavingObservation = true;
        break;
      case SAVE_OBSERVATION_SUCCESS:
        draft.isSavingObservation = false;
        break;
      case SAVE_OBSERVATION_FAILURE:
        draft.isSavingObservation = false;
        break;
      // Add Template Data
      case ADD_TEMPLATE_DATA:
        draft.isAddingTemplateData = true;
        break;
      case ADD_TEMPLATE_DATA_SUCCESS:
        draft.isAddingTemplateData = false;
        break;
      case ADD_TEMPLATE_DATA_FAILURE:
        draft.isAddingTemplateData = false;
        break;
      case GET_REVISION:
        draft.isFetchingHistory = true;
        draft.history = [];
        break;
      case GET_REVISION_SUCCESS:
        draft.isFetchingHistory = false;
        draft.history = action.payload;
        break;
      case GET_REVISION_FAILURE:
        draft.isFetchingHistory = false;
        draft.history = [];
        break;
      case VIEW_REVISION:
        draft.isViewingRevision = true;
        draft.revision = null;
        break;
      case VIEW_REVISION_SUCCESS:
        draft.isViewingRevision = false;
        draft.revision = action.payload;
        break;
      case VIEW_REVISION_FAILURE:
        draft.isViewingRevision = false;
        draft.revision = null;
        break;
      // Get Governance Stats
      case GET_GOVERNANCE_STATS:
        draft.isFetchingGovernanceStats = true;
        draft.governanceStats = null;
        break;
      case GET_GOVERNANCE_STATS_SUCCESS:
        draft.isFetchingGovernanceStats = false;
        draft.governanceStats = action.payload;
        break;
      case GET_GOVERNANCE_STATS_FAILURE:
        draft.isFetchingGovernanceStats = false;
        draft.governanceStats = null;
        break;
      case UPDATE_PLAN_STATUS:
        draft.isUpdatingPlanStatus = true;
        break;
      case UPDATE_PLAN_STATUS_SUCCESS:
        draft.isUpdatingPlanStatus = false;
        break;
      case UPDATE_PLAN_STATUS_FAILURE:
        draft.isUpdatingPlanStatus = false;
        break;
      default:
        return state;
    }
  });

export default ResidentAssessmentReducer;
